import React, {
	Component
} from 'react';
import { Layout, Menu, Icon, Button, Select, message } from 'antd';
import { Route, Link, Switch } from 'react-router-dom';
import asyncComponent from '../utils/AsyncComponent';
import './style.css';
import '@/css/common.css';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import storage from '../utils/cookie'
import { action as userInfoAction } from './';
import Login from '../login';
import axios from 'axios';
import API from '../API/api';
import * as questionManageType from '../utils/questionManageType';



const SubMenu = Menu.SubMenu,
	  Option = Select.Option,
	  {
		Header,
		Footer,
		Sider,
		Content
	  } = Layout;

const AsyncQuestionBox = asyncComponent(() =>import('./question_box/view.js'))
const AsyncWelcome = asyncComponent(() =>import('../welcome/view.js'))
const AsyncQuestionManage = asyncComponent(() =>import('./question_manage/view.js'))
const AsyncAuthorityManage = asyncComponent(() =>import('./authority_manage/view.js'))
const AsyncPersonManage = asyncComponent(() =>import('./person_manage/view.js'))
const AsyncQuestionError = asyncComponent(() =>import('./question_error/view.js'))
const AsyncKnowledgeAssist = asyncComponent(() =>import('./knowledge_assist/view.js'))
const AsyncQuestionPackage = asyncComponent(() =>import('./question_package/view.js'))
	

class App extends Component {
	static childContextTypes={
	    dispatch: React.PropTypes.func.isRequired
	}
	
	static contextTypes = {
		router: PropTypes.object.isRequired
	};
	state = {
		selectedKeys: window.location.href.split('/')[4],
		subject: '0',
		grade_part: '10',
		collapsed: false,
	}
	getChildContext() {
	    return {
		    	dispatch: this.props.dispatch
		};
	}
	componentWillUpdate() {
		this.state.selectedKeys = window.location.href.split('/')[4]
		let hasSubMenu=['questionmanage','questionError','knowledgeAssist','questionPackage'].includes(this.state.selectedKeys)
		if(hasSubMenu) {
			this.state.selectedKeys = window.location.href.split('/')[5]
		}
	}
	componentWillMount() {
		const token = storage.getData('UCENTER_IUCTOKEN');
		!token && this.props.history.push('/login');
	}

	componentDidMount() {
		if(storage.getData('UCENTER_IUCTOKEN')) {
			this.props.getUserInfo(() => {
				this.setState({
					subject: this.props.user.subject,
					grade_part: this.props.user.grade_part
				})
			});
			this.props.changePath('questionbox');
		}
	}
	loginOut = (e) => {
		storage.delData('UCENTER_IUCTOKEN');
		axios.get(API.EXIT_LOGIN).then((res) => {
			window.token = '';
			this.context.router.history.push('/login');
			this.props.changePath('login');
		});
	};
	onMenuClick = (e) => {
		this.props.changePath(e.key);
	}

	/*修改学科学段*/
	handleClick = (grade_part, subject, str) => {
		axios.post(API.UPDATE_SUBJECT, {
			grade_part,
			subject
		}).then((res) => {
			res = res.data
			if(res.code === 0) {
				message.success(`修改${str}成功`)
				this.setState({
					grade_part,
					subject
				})
				window.location.reload();
			} else {
				message.error(res.message);
			}
		}, (error) => {
			message.error('网络错误！');
		});
	}
	initSubjectPart(){
		let SUBJECT_PART = {}
		switch(this.props.user.product) {
			//2-速算
			case 2:
				SUBJECT_PART = {
					'0': '数学',
					'10': '科学'
				}
				break;
			//4-ai直播课；5-直播课
			case 4:
			case 5:
				SUBJECT_PART = {
					'0': '数学'
				}
				break;
			//6-语文
			case 6:
				SUBJECT_PART = {
					'1': '语文'
				}
				break;
			//7-英语
			case 7:
			case 8:
				SUBJECT_PART = {
					'2': '英语'
				}
				break;
			case 11:
				SUBJECT_PART = {
					'51': '素质课'
				}
				break;
			default:
				break;

		}
		if(!SUBJECT_PART[this.state.subject]) {
			SUBJECT_PART[this.state.subject] = questionManageType.SUBJECT_PART[this.state.subject]
		}
		return SUBJECT_PART
	}

	render() {
		
		if(!this.props.user) {
			return null
		}
		let SUBJECT_PART = this.initSubjectPart()

		let questionColorGray = localStorage.getItem('questionColorGray')
		questionColorGray = (questionColorGray === 'true')

		//将挂在props下的reducer通过props传递到所有子组件
		let  {questionBox,user,questionManage,knowledgeAssist,questionPackage}=this.props; 
		
		return(
			<div style={{height: '100%'}} id="contentBody" className={questionColorGray?'questionColorGray':''}>	
			    <Layout>
			      <Header style={{ position: 'fixed', width: '100%',zIndex:20}}>
			      		<div className="head-container">
		                    <div className="logo">
		                        <img alt={`MIS题库平台`} height={36} width={40} src={require('../static/img/pc-logo.jpeg')} style={{verticalAlign: 'middle'}}/>      

		                    </div>
		                    {
		                        this.props.user.product&&
		                        <div className="title">
		                            <span style={{verticalAlign: 'middle'}}>作业盒子-MIS</span>
		                            <Select value={this.state.grade_part} style={{width: 80, marginLeft: 15}} onSelect={(val)=>this.handleClick(val,this.state.subject,'学段')}>
		                                {
		                                    Object.keys(questionManageType.GRADE_PART).map(k=>
		                                        <Option key={k} value={k}>{questionManageType.GRADE_PART[k]}</Option>
		                                    )
		                                }
		                            </Select>
		                            <Select  value={this.state.subject} style={{width: 80, marginLeft: 5}} onSelect={(val)=>this.handleClick(this.state.grade_part,val,'学科')}>
		                                {
		                                    Object.keys(SUBJECT_PART).map((k)=>
		                                        <Option key={k} value={k}>{SUBJECT_PART[k]}</Option>
		                                    )
		                                }
		                            </Select>
		                        </div>
		                   }
		                    <div className="user-info">
		                        <div className="user-name">
		                            <div style={{
		                                fontSize: '14px',
		                                marginRight: '15px',
		                                display: 'inline-block',
		                                verticalAlign: 'middle'
		                            }}>{this.props.userName}</div>
		                            <Button type="primary" style={{
		                                verticalAlign: "middle",
		                                backgroundColor: '#5a9bfe',
		                                borderColor: '#5a9bfe'
		                            }} onClick={this.loginOut}>退出</Button>
		                        </div>
		                    </div>
		                    {/*题干换颜色的部分*/}
		                    <div className="user-info">
		                        <div className="user-name">
		                            <Button onClick={()=>{localStorage.setItem('questionColorGray',!questionColorGray);this.setState({questionColorGray:!questionColorGray})}}
		                                    type={questionColorGray?'primary':''}>题干灰色</Button>
		                        </div>
		                    </div>
		                </div>
			      </Header>
			     
			      <Layout style={{paddingTop:'58px'}}>
			        <Sider style={{position:'fixed',height:'100%',zIndex:20}}
			        		 	onCollapse={()=>{this.setState({collapsed:!this.state.collapsed})}}
					        collapsible
					        collapsed={this.state.collapsed}
			        >
		                <div className="nav-container" >
		                    <div className="menu">
		                        <Menu
		                            style={{fontSize: '20px'}}
		                            mode="inline"
		                            theme="light"
		                            onClick={this.onMenuClick}
		                            selectedKeys={[this.state.selectedKeys]}
		                            defaultOpenKeys={[this.state.selectedKeys]}
		                        >
		                            {
		                                this.props.user.role_qbox&&
		                                <Menu.Item key="questionbox">
		                                    <Link to="/questionbox"/>
		                                    <Icon type="home"/>
		                                    <span style={{fontSize: "16px"}}>题盒子</span>
		                                </Menu.Item>
		                            }
		                            {
		                                this.props.user.role_qadmin&&
		                                <SubMenu key="questionmanage" title={<span><Link to="/questionmanage/lookoverquestion"/><Icon type="book" /><span style={{fontSize: "16px"}}>题目管理</span></span>}>
		                                    {
		                                        this.props.user.role_qadmin.role_qshow&&
		                                        <Menu.Item key={'lookoverquestion'}><Link to="/questionmanage/lookoverquestion"/>查看题目</Menu.Item>
		                                    }
		                                    {
		                                        this.props.user.role_qexplain&&
		                                        <Menu.Item key={'questionexplain'}><Link to="/questionmanage/questionexplain"/>题目解析</Menu.Item>
		                                    }
		                                    {
		                                        this.props.user.role_qselect &&
		                                        <Menu.Item key={'settag'}><Link to="/questionmanage/settag"/>打标签</Menu.Item>
		                                    }
		                                    {
		                                        this.props.user.role_qstatistics &&
		                                        <Menu.Item key={'questionExport'}><Link to="/questionmanage/questionExport"/>题目导出</Menu.Item>
		                                    }
		                                    {
		                                        this.props.user.role_evaluation&&
		                                        <Menu.Item key={'questionevaluating'}><Link to="/questionmanage/questionevaluating"/>评测&精题任务</Menu.Item>
		                                    }
		                                    {
		                                        this.props.user.role_icon&&this.props.user.subject=='0'&&
		                                        <Menu.Item key={'imageCorrection'}><Link to="/questionmanage/imageCorrection"/>图片订正</Menu.Item>
		                                    }
		                                    {
		                                       	this.props.user.role_qcheck&&this.props.user.subject=='0'&&
		                                        <Menu.Item key={'checkBeyondLevel'}><Link to="/questionmanage/checkBeyondLevel"/>查超纲</Menu.Item>
											}
											{
												this.props.user.subject=='2' &&
												<Menu.Item key={'questionTemplate'}><Link to="/questionmanage/questionTemplate"/>题型模版</Menu.Item>	
											}
		
		                                </SubMenu>
		                            }
		
		                            {
		                                ((this.props.user.role_know&&Object.keys(this.props.user.role_know).length)||
		                                (this.props.user.role_assist&&Object.keys(this.props.user.role_assist).length))&&
		                                <SubMenu key="knowledgeAssist" title={<span><Link to="/knowledgeAssist/treeManage"/><Icon type="fork" /><span style={{fontSize: "16px"}}>知识点&教辅管理</span></span>}>
		                                    {
		                                        this.props.user.role_know&&Object.keys(this.props.user.role_know).length&&
		                                        <Menu.Item key={'treeManage'}><Link to="/knowledgeAssist/treeManage"/>知识点管理</Menu.Item>
		                                    }
		                                    {
		                                        this.props.user.role_assist&&Object.keys(this.props.user.role_assist).length&&
		                                        <Menu.Item key={'assistManage'}><Link to="/knowledgeAssist/assistManage"/>教辅管理</Menu.Item>
		                                    }
		                                    {
		                                        this.props.user.role_cateitem&&Object.keys(this.props.user.role_cateitem).length&&
		                                        (this.props.user.subject=='1'||this.props.user.subject=='2')&&
		                                        <Menu.Item key={'wordBankManage'}><Link to="/knowledgeAssist/wordBankManage"/>字词库管理</Menu.Item>
		                                    }
		                                    {
		                                        this.props.user.role_album&&Object.keys(this.props.user.role_album).length&&
		                                        (this.props.user.subject=='1'||this.props.user.subject=='2')&&
		                                        <Menu.Item key={'albumManage'}><Link to="/knowledgeAssist/albumManage"/>专辑管理</Menu.Item>
		                                    }
		                                    {
		                                        this.props.user.role_cateitem&&Object.keys(this.props.user.role_cateitem).length&&
		                                        (this.props.user.subject=='1')&&
		                                        <Menu.Item key={'articleManage'}><Link to="/knowledgeAssist/articleManage"/>文章库管理</Menu.Item>
		                                    }
		
		                                </SubMenu>
		                            }
		                            {
		                              	(this.props.user.role_video||this.props.user.role_qselectbag)&&
		                            		<SubMenu key="questionPackage" title={<span><Icon type="folder" /><span style={{fontSize: "16px"}}>题库&题包管理</span></span>}>
		                            			 {this.props.user.role_video&&<Menu.Item key='manage'><Link to="/questionPackage/manage"/>视频题包</Menu.Item>}
		                            			 {this.props.user.role_video&&<Menu.Item key='questionView'><Link to="/questionPackage/questionView"/>题包查看</Menu.Item>}
		                            			 {this.props.user.role_qselectbag&&<Menu.Item key='goodPackage'><Link to="/questionPackage/goodPackage"/>人工精题包</Menu.Item>}
		                            		</SubMenu>
		                            }
		                            {
		                                this.props.user.role_qerrcheck&&
		                                <SubMenu key="questionError" title={<span><Link to="/questionError/DailyError"/><Icon type="exception" /><span style={{fontSize: "16px"}}>题目检错</span></span>}>
		                                    {
		                                        this.props.user.role_qerrcheck.dailyList&&
		                                        <Menu.Item key={'DailyError'}><Link to="/questionError/DailyError"/>日常报错</Menu.Item>
		                                    }
		                                    {
		                                        this.props.user.role_qerrcheck.homeworkTaskList&&
		                                        <Menu.Item key={'outWorkerError'}><Link to="/questionError/outWorkerError"/>外包报错</Menu.Item>
		                                    }
		                                    {
		                                        this.props.user.role_qerrcheck.blackList&&
		                                        <Menu.Item key={'blacklist'}><Link to="/questionError/blacklist"/>黑名单管理</Menu.Item>
		                                    }
		                                </SubMenu>
		                            }
		                            {
		                                this.props.user.role_auth_group&&Object.keys(this.props.user.role_auth_group).length&&
		                                <SubMenu key="authoritymanage" title={<span><Link to="/authoritymanage/questionexplain"/>
		                                <Icon type="team" />
		                                <span style={{fontSize: "16px"}}>组管理</span></span>}>
		
		                                    {
		                                        this.props.user.role_auth_group.qexplain&&
		                                        <Menu.Item key={'authoritymanage'}><Link to="/authoritymanage/questionexplain"/>题目解析</Menu.Item>
		                                    }
		                                </SubMenu>
		                            }
		                            {
		                                this.props.user.role_auth_user>0&&
		                                <Menu.Item key="personmanage">
		                                    <Link to="/personmanage"/>
		                                    <Icon type="solution"/>
		                                    <span style={{fontSize: "16px"}}>人员管理</span>
		                                </Menu.Item>
		                            }
		
		                        </Menu>
		                    </div>
		                </div>
		               
			        </Sider>
			        <Content style={this.state.collapsed?{paddingLeft:'80px',width:'100%'}:{paddingLeft:'200px',width:'100%'}}>
			        		<div className={"app-container"} >
		                    <div className="questionListScroll" style={{ height: '100%', width: '100%'}}>
		                        <Switch>
		                            <Route exact path="/" component={AsyncWelcome}/>
		                            <Route path="/login" component={Login}/>
		                            <Route path="/questionbox" component={AsyncQuestionBox}/>
		                            <Route path="/questionmanage" component={AsyncQuestionManage}/>
		                            <Route path="/authoritymanage" component={AsyncAuthorityManage}/>
		                            <Route path="/personmanage" component={AsyncPersonManage}/>
		                            <Route path="/questionError" component={AsyncQuestionError}/>
		                            <Route path="/knowledgeAssist" component={AsyncKnowledgeAssist}/>
		                            <Route path="/questionPackage" component={AsyncQuestionPackage}/>
		                        </Switch>
		                    </div>
		                </div>
			        </Content>
			      </Layout>
			    </Layout>
            </div>
		);
	}
}

const mapStateToProps = (state) => {
    //在根组件挂载所有reducer到props
	const {questionBox,user,questionManage,knowledgeAssist,questionPackage} = state;
	return {
		userName: user.username,
		questionBox,
		user,
		questionManage,
		knowledgeAssist,
		questionPackage
	};
}
const mapDispatchToProps = dispatch => {
	return {
		changePath: (path) => {
			dispatch(userInfoAction.changePath(path));
		},
		getUserInfo: (callback) => {
			dispatch(userInfoAction.getUserInfo(callback))
		},
		dispatch
	}
};
export default connect(mapStateToProps, mapDispatchToProps)(App);


// WEBPACK FOOTER //
// ./src/entry_app/view.js